import script from "./BulkFileUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkFileUpload.vue?vue&type=script&setup=true&lang=js"

import "./BulkFileUpload.vue?vue&type=style&index=0&id=53e59e12&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e59e12"]])

export default __exports__